import styled, { css } from "styled-components";

import { COLOR } from "@sellernote/ui/src/sds-v2/styles/colors";
import { mobile } from "@sellernote/ui/src/styles/functions";

const container = styled.div`
  position: relative;
  width: 100%;
  min-width: 1280px;

  ${mobile(css`
    min-width: 100%;
  `)};
`;

const faqContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .requirement {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .description {
      padding-left: 16px;
    }
  }

  em {
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: -0.25px;
    color: ${COLOR.point_400};
  }
`;

const faq = styled.p`
  em {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.2px;
    color: ${COLOR.point_400};
  }
`;

const faqWithBold = styled.p`
  em {
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: -0.25px;
    color: ${COLOR.point_400};
  }
`;

const faqWithTable = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  p {
    em {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: -0.2px;
      color: ${COLOR.point_400};
    }
  }
`;

export default {
  container,
  faqContainer,
  faq,
  faqWithBold,
  faqWithTable,
};
